import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportingService } from 'src/app/services/reporting.service';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import { Table } from 'primeng/table';
import { SelectItem } from 'primeng/api';
import * as moment from 'moment';
import * as Chart from 'chart.js';
import * as ChartDataLabels from 'chartjs-plugin-datalabels';
import { EncryptionService } from 'src/app/services/encryption.service';
import { FacturationService } from 'src/app/services/facturation.service';
import { PerformanceService } from 'src/app/services/performance.service';
@Component({
  selector: 'app-reporting-client',
  templateUrl: './reporting-client.component.html',
  styleUrls: ['./reporting-client.component.css']
})
export class ReportingClientComponent implements OnInit {
   // Declaration variable
  // --- Parametre Affichage
  VolumetrieFiltre: any[] = [
    {label : 'Volumétrie des fiches reçues', value : 0},
    {label : 'Volumétrie des fiches traitées au global', value : 1},
    {label : 'Nombre de fiches KO en attente retour PTL', value : 2},
  ];
  selectedOptionVolumetrie = 1;
  valueDate: Date;
  valueSemaine: Date;
  valuMois: Date;
  valuePeriode: Date;
   // ---- Variable Special Section Information General
   // Fiches Recues -- Valeur En nombre
   FicheRecues = 0;
   // Fiche Traitées -- Valeur En nombre
   FicheTraitees = 0;

  dureeMoyenneTraitementInitial: string;
  dureeMoyenneTraitementRetour: string;
   // Graphe PIE CHART
   dataGraphePieGeneral: any;
  plugin = ChartDataLabels;
  options = {
    plugins: {
      datalabels: {
        /* show value in percents */
        formatter: (value, ctx) => {
          let sum = 0;
          const dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map(data => {
            sum += data;
          });
          const percentage = (value * 100 / sum);
          // return percentage !== 0 ? percentage.toFixed(2) + '%' : '';
          return value;
        },
        color: '#fff',
      }
    }
  };
  nombre_fiche_ok = 0;
  nombre_fiche_ko = 0;
  // Nombre Echantillon CQ
  FicheEchantillonerISO = 0;
  TauxQualiteISO = 0;
  FicheEchantillonerCIBLE = 0;
  NombreErreurCIBLE = 0;
  TauxQualiteCIBLE = 0;
   // Nombre Total de fiches KO
   NombreTotalFicheKO = 0;


  recuLists: any[] = [];
  recuCols: any = [ // => Colonnes du tableau volumétrie reçue
    {field: 'date_reception', header: 'Date'},
    {field: 'heure_reception', header: 'Heure'},
    {field: 'num_point_accueil', header: 'ID PTL'},
    {field: 'id_complexite', header: 'Complexité'},
    {field: 'fin_traitement', header: 'Date fin de traitement'}
  ];

  complexteFilter: SelectItem[] = [
    {label : 'FORTE', value : 3 },
    {label : 'MOYENNE', value : 2 },
    {label : 'FAIBLE', value : 1 }
  ];

  traitesCols: any[] = [ // => Colonnes du tableau volumétrie traitée
    {field: 'date_action', header: 'Date'},
    {field: 'heure_action', header: 'Heure'},
    {field: 'num_point_accueil', header: 'ID PTL'},
    {field: 'id_complexite', header: 'Complexité'},
  ];
  traitesLists: any[] = [];

  koEnAttenteCols: any[] = [
    {field: 'date_action', header: 'Date'},
    {field: 'heure_action', header: 'Heure'},
    {field: 'num_point_accueil', header: 'ID PTL'},
    {field: 'id_complexite', header: 'Complexité'},
    {field: 'contenu_ko', header: 'Contenus KO'}
  ];
  koEnAttenteLists: any[] = [];

  fr: any;
  activeIndexTabView = 0;
  @ViewChild('recus') table: Table;
  // Date HTML
  public dateDebutFiltre = '';
  public dateFinFiltre = '';


  maturiteInitiale : '';
  maturiteRetour : '';
  user : Object = {};


  dmtinitiale = {
    faible : '',
    moyenne : '',
    forte : ''
  };

  dmtRetour = {
    faible : '',
    moyenne : '',
    forte : ''
  };

  dmtGlobalAccepteInitial:string="";
  dmtGlobalAccepteRetour:string="";

  constructor(private reportingService: ReportingService, private dateService: DateCalculationService,private encryptService:EncryptionService, private performanceService:PerformanceService) { }

      ngOnInit(): void {
          this.user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
          this.fr = this.dateService.getFrLocale();
          const date_filtre = this.getDateToday();
          this.dateDebutFiltre =  moment(date_filtre.date_deb).format('DD/MM/YYYY');
          this.dateFinFiltre = moment(date_filtre.date_fin).format('DD/MM/YYYY');
          
          this.getDatas(date_filtre.date_deb, date_filtre.date_fin);
      }


      getDatas(dateDebut:string, dateFin:string) {
        let debut = new Date(dateDebut);
        let fin = new Date(dateFin);
        let depasse = this.dateService.checkIfPlusNDays(debut, fin, 92);

        if(!depasse) {
          this.getDataReportingClientGeneral(dateDebut, dateFin);
          //this.getDetails(dateDebut, date_filtre.date_fin);
          this.getMaturite(dateDebut, dateFin);
          this.getTauxIso(dateDebut, dateFin);

          this.getDmtParComplexite(dateDebut, dateFin, false);
          this.getDmtParComplexite(dateDebut, dateFin, true);

        } else {
          alert("Veuillez choisir une intervalle de date moins longue");
        }
      }

      // Recuperation date
      getDateToday() {
        const date_string_Deb  = moment().format('YYYY-MM-DD');
        const objectDate = {
          date_deb: date_string_Deb,
          date_fin: date_string_Deb, // '2020-09-10'
        };
        // alert(JSON.stringify(objectDate));
        return objectDate;
      }

      // Fonction pour Multi Range Date
      selectRangeWeek(evt) {
        const start = new Date(evt);
        start.setDate(start.getDate() - start.getDay() + 1);
        this.valueSemaine[0] = start;
        const end = new Date(start);
        end.setDate(start.getDate() + 6);
        this.valueSemaine[1] = end;
      }


      // Fonction Recuperation Information Generale
      getDataReportingClientGeneral(date_deb, date_fin) {
        const options = {
          date_deb,
          date_fin, // '2020-09-10'
        };
        this.reportingService.getReportingGeneral(options).subscribe( (value: any) => {
          if (value.status !== 'success'){
            console.log('Une erreur dans la requête:' + JSON.stringify(value.cause));
          } else {
            // Assignation DATA Afficher
            console.log(value);
            this.FicheRecues = value.nombre_recues;
            this.FicheTraitees = value.nombre_traiter;
            //this.dureeMoyenneTraitementInitial = this.dateService.formatSeconds(value.duree_moyenne_initial);
            //this.dureeMoyenneTraitementRetour = this.dateService.formatSeconds(value.duree_moyenne_retour);
            this.nombre_fiche_ok = value.nombre_fiche_ok;
            this.nombre_fiche_ko = value.nombre_fiche_ko;
            this.NombreTotalFicheKO = value.nombre_attente_retour_ko;
            // ASSIGNER VALEUR CQ
            // -- iso
            this.FicheEchantillonerISO = value.nombre_echantilloner_iso;
            //this.TauxQualiteISO = value.taux_qualite_iso;
            // -- cible
            this.FicheEchantillonerCIBLE = value.nombre_echantilloner_cible;
            this.TauxQualiteCIBLE = value.taux_qualite_cible;
            this.NombreErreurCIBLE = value.nombre_erreur_cible;
            this.modifierPieChart(this.nombre_fiche_ok, this.nombre_fiche_ko);
          }
        });
      }

      getDmtParComplexite(dateDebut, dateFin, retour) {
        let idRetour = 'retours';
        if(retour === false) idRetour = 'initiales'; 
        this.performanceService.getDmtMoyenneParComplexite(dateDebut, dateFin, 0, "all", idRetour)
        .subscribe((value) => {
          if (value["status"] !== 'success'){
            console.log('Une erreur dans la requête:' + value["cause"]);
          }else {
            console.log(value["data"]);
            let datas = value["data"];

            if(retour === false) {
              this.dmtinitiale.faible = this.dateService.formatSeconds(datas.faible);
              this.dmtinitiale.moyenne = this.dateService.formatSeconds(datas.moyenne);
              this.dmtinitiale.forte = this.dateService.formatSeconds(datas.forte);
              this.dureeMoyenneTraitementInitial = this.dateService.formatSeconds(parseInt(datas.total));
              this.dmtGlobalAccepteInitial = this.dateService.formatSeconds(parseInt(datas.maxTotalAccepte));
            } else {
              this.dmtRetour.faible = this.dateService.formatSeconds(datas.faible);
              this.dmtRetour.moyenne = this.dateService.formatSeconds(datas.moyenne);
              this.dmtRetour.forte = this.dateService.formatSeconds(datas.forte);
              this.dureeMoyenneTraitementRetour = this.dateService.formatSeconds(parseInt(datas.total));
              this.dmtGlobalAccepteRetour = this.dateService.formatSeconds(parseInt(datas.maxTotalAccepte));

            }
          }
        })
      }



      /**
       * Liste des fiches à afficher dans le tableau
       */
      getDetails(dateDebut, dateFin) {
        this.reportingService.getListeFichesRecues(dateDebut, dateFin).subscribe((value: any) => {
          if (value["status"] !== 'success'){
            console.log('Une erreur dans la requête:' + value["cause"]);
          }else {
            this.recuLists = value["data"];
          }
        });

        this.reportingService.getListeFichesTraitees(dateDebut, dateFin).subscribe((value: any) => {
          if (value['status'] !== 'success'){
            console.log('Une erreur dans la requête:' + value['cause']);
          }else {
            this.traitesLists = value['data'];
          }
        });

        this.reportingService.getListeKoEnAttenteRetour(dateDebut, dateFin).subscribe( (value: any) => {
          if (value.status !== 'success'){
            console.log('Une erreur dans la requête:' + value.cause);
          }else {
            this.koEnAttenteLists = value.data;
          }
        });

      }




      // FOnction pour Modifier Graphe
      modifierPieChart(fiches_ok, fiches_ko) {
        this.dataGraphePieGeneral = {
          labels: ['Fiches OK', 'Fiche KO'],
          datasets: [
            {
              data: [fiches_ok, fiches_ko],
              backgroundColor: [
                '#0c910c',
                '#c41605',
              ],
              hoverBackgroundColor: [
                '#0c910c',
                '#eb1300',
              ]
            }],
        };
       }


       onRecuDateRecepSelect(value){
        const date = this.dateService.getFormatedDate(value);
        this.table.filter(date.date, 'date_reception', 'contains');
      }

      onRecuDateFinSelect(value){
        const date = this.dateService.getFormatedDate(value);
        this.table.filter(date.date, 'fin_traitement', 'contains');
      }


      onTraiteDateSelect(value){
        const date = this.dateService.getFormatedDate(value);
        this.table.filter(date.date, 'date', 'contains');
      }

      getComplexite(idComplexite: number) {
        switch (idComplexite) {
          case(1) : {
            return 'FAIBLE';
            break;
          }
          case(2) : {
            return 'MOYENNE';
            break;
          }
          case(3) : {
            return 'FORTE';
            break;
          }
        }
      }


      // Filtre Reporting
      loadFiltreReporting() {
        // alert(this.activeIndexTabView);
        const filtre_date = this.getDateFromCurrentTabView();
        this.dateDebutFiltre =  moment(filtre_date.date_deb).format('DD/MM/YYYY');
        this.dateFinFiltre = moment(filtre_date.date_fin).format('DD/MM/YYYY');
        const filtre_volumetrie = this.selectedOptionVolumetrie;
        if (filtre_date == null)
        {
          alert('Veuillez selecitonner une date');
          return;
        }
        // CHargement Filtre Date
        this.getDatas(filtre_date.date_deb, filtre_date.date_fin);
      
      }

      // Recuperation Valeur Date Filtre
      getDateFromCurrentTabView() {
        switch (this.activeIndexTabView) {
          // CALENDAR DATE
          case(0) : {
            const date_string  = moment(this.valueDate).format('YYYY-MM-DD');
            const objectDate = {
              date_deb: date_string,
              date_fin: date_string,
            };
            return objectDate;
            break;
          }
          // CALENDAR SEMAINE
          case(1) : {
            const date_string_Deb  = moment(this.valueSemaine[0]).format('YYYY-MM-DD');
            const date_string_Fin  = moment(this.valueSemaine[1]).format('YYYY-MM-DD');
            const objectDate = {
              date_deb: date_string_Deb,
              date_fin: date_string_Fin, // '2020-09-10'
            };
            // alert(JSON.stringify(objectDate));
            return objectDate;
            break;
          }
          // CALENDAR MOIS
          case(2) : {
            const date_string_Deb  = moment(this.valuMois).format('YYYY-MM-DD');
            const date_string_Fin  = moment(this.valuMois).endOf('month').format('YYYY-MM-DD');
            const objectDate = {
              date_deb: date_string_Deb,
              date_fin: date_string_Fin, // '2020-09-10'
            };
            // alert(JSON.stringify(objectDate));
            return objectDate;
            break;
          }
          // CALENDAR PERIODE
          case(3) : {
            const date_string_Deb  = moment(this.valuePeriode[0]).format('YYYY-MM-DD');
            const date_string_Fin  = moment(this.valuePeriode[1]).format('YYYY-MM-DD');
            let objectDate = {
              date_deb: date_string_Deb,
              date_fin: date_string_Fin,
            };
            if (date_string_Fin === 'Invalid date')
            {
              objectDate = {
                date_deb: date_string_Deb,
                date_fin: date_string_Deb,
              };
            }
            return objectDate;
            break;
          }
        }
      }

      // Recuperation date J-1
      getDateYesterday() {
        const date_string_Deb  = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const objectDate = {
          date_deb: date_string_Deb,
          date_fin: date_string_Deb, // '2020-09-10'
        };
        // alert(JSON.stringify(objectDate));
        return objectDate;
      }


      getMaturite(dateDebut:string, dateFin:string) {
        this.reportingService.getMaturiteMoyenne(dateDebut,dateFin).subscribe( value => {
            if (value['status'] !== 'success'){
              console.log('Une erreur dans la requête:' + JSON.stringify(value['cause']));
            } else {
              let data = value['data'];
              this.maturiteInitiale = '';
              console.log(data);
              if(data.initiale.days) {
                this.maturiteInitiale += data.initiale.days + ' J ';
              }

              if(data.initiale.hours) {
                this.maturiteInitiale += data.initiale.hours + ' H ';
              }

              if(data.initiale.minutes) {
                this.maturiteInitiale += data.initiale.minutes + ' min'
              }

              this.maturiteRetour = '';

              if(data.retour.days) {
                this.maturiteRetour += data.retour.days + ' J ';
              }

              if(data.retour.hours) {
                this.maturiteRetour += data.retour.hours + ' H ';
              }

              if(data.retour.minutes) {
                this.maturiteRetour += data.retour.minutes + ' min'
              }
            }
        });
      }


      getTauxIso(dateDebut:string, dateFin:string) {
        this.reportingService.getTauxIso(dateDebut,dateFin).subscribe( value => {
          if (value['status'] !== 'success'){
            console.log('Une erreur dans la requête:' + JSON.stringify(value['cause']));
          } else {
            console.log("taux : " + value['data']);
            this.TauxQualiteISO = this.round(value['data'], 2);
          }
        });
      }

      //arrondie les chiffres après la virgule
      round (number, decimalPlaces) {
        const factorOfTen = Math.pow(10, decimalPlaces)
        return Math.round(number * factorOfTen) / factorOfTen
      }


      isClient() {
        return (parseInt(this.user['droit']) === 3) ? true : false;
      }

}
